<form [formGroup]="form" class="app-install-trigger-form app-permissions-update-trigger-form">

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="permissionModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
    title="Updated Permissions"
    generateHint="The test will generate plausible post-update permissions and create a sandbox PERMISSIONS_UPDATE event at the flow's configured interval."
    specifyHint="These are the post-update values the flow will evaluate as Device.allows_push and Device.location_permission."
  ></app-flow-test-app-state-section>

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>
</form>
